module.exports = __webpack_public_path__ + "media/images/logo/logo-1a713af727b49d8b3c621b9d82dcebc9.png";